module.exports = __webpack_public_path__ + "static/media/highly-scalable.42e0e03e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/highly-scalable.svg
// module id = 435
// module chunks = 0